import { createSlice } from "@reduxjs/toolkit";

const Dispute = createSlice({
  name: "Dispute",
  initialState: {
    canSeeDisputButton: false,
    canSeeWithdrawButton: false,
    canSeeDisputSection: false,
    canSeeCarrierProgressButton: false,
    cancleDisputMessage: "",
    progrssBarStatus: "",
    singleDisputObj: {}
  },
  reducers: {
    canSeeDisputButtonValue: (state, action) => {
      state.canSeeDisputButton = action.payload.canSeeDisputButton;
    },
    progrssBarStatusValue: (state, action) => {
      state.progrssBarStatus = action.payload.progrssBarStatus;
    },
    canSeeWithdrawButtonValue: (state, action) => {
      state.canSeeWithdrawButton = action.payload.canSeeWithdrawButton;
    },
    canSeeDisputSectionValue: (state, action) => {
      state.canSeeDisputSection = action.payload.canSeeDisputSection;
    },
    singleDisputObjValue: (state, action) => {
      state.singleDisputObj = action.payload.singleDisputObj;
    },
    cancleDisputMessageValue: (state, action) => {
      state.cancleDisputMessage = action.payload.cancleDisputMessage;
    },
    canSeeCarrierProgressButtonValue: (state, action) => {
      state.canSeeCarrierProgressButton = action.payload.canSeeCarrierProgressButton;
    }
  },
});

export const {
  canSeeDisputButtonValue,
  canSeeWithdrawButtonValue,
  canSeeDisputSectionValue,
  singleDisputObjValue,
  cancleDisputMessageValue,
  progrssBarStatusValue,
  canSeeCarrierProgressButtonValue
} = Dispute.actions;
export default Dispute.reducer;